export function capitalizeFirstLetter(s: string): string {
  return (s.charAt(0).toUpperCase() + s.slice(1).toLocaleLowerCase()).replaceAll("_", " ");
}

export function uniqueArray (arr: Array<any>) {
  return new Array(new Set(arr));
}

export function addUnique (arr: Array<any>, item: any) {
  return uniqueArray(arr.concat([item]));
}

export function replace(arr: Array<any>, a: any, b: any) {
  return arr.map(i => i === a ? b : i);
}